import { useRef, useState, useEffect, useContext, useCallback, useMemo } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import axios from "axios";

import { Dialog } from "primereact/dialog";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { BarrioContext } from "../components/BarrioContext";
import { useAuth } from "../components/AuthContext";
import { useTerminologia } from "../hooks/useTerminologia";

import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';

const UnidadFuncional = () => {
    const toast = useRef(null);
    const HOST_API = process.env.REACT_APP_URL;
    const { barrio } = useContext(BarrioContext);
    const { administracionId } = useAuth();
    const t = useTerminologia();
    const [loadingBackdrop, setLoadingBackdrop] = useState(false);

    // â”€â”€â”€ Helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const camelToHeader = (key) =>
        key.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase()).trim();

    const formatValue = (value, type) => {
        if (value === null || value === undefined) return "";
        switch (type) {
            case "date":
                return new Date(value).toLocaleDateString("es-AR");
            case "currency":
                return typeof value === "number"
                    ? value.toLocaleString("es-AR", { style: "currency", currency: "ARS" })
                    : value;
            default:
                return typeof value === "object" ? JSON.stringify(value) : value;
        }
    };

    const flattenRow = (row) => {
        const flat = {};
        for (const [key, value] of Object.entries(row)) {
            if (typeof value === "object" && value !== null && !key.endsWith("_type")) {
                for (const [nestedKey, nestedValue] of Object.entries(value)) {
                    flat[nestedKey] = nestedValue;
                    flat[`${nestedKey}_type`] = row[`${key}_type`] ?? "currency";
                }
            } else {
                flat[key] = value;
            }
        }
        return flat;
    };

    // â”€â”€â”€ Estado â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const initialFormData = {
        unidadFuncionalId: 0,
        unidadFuncional: "",
        direccion: "",
        bloque: "",
        unidadComplementariaCochera: "",
        partidaArba: "",
        departamento: "",
        ph: "",
        planoUnidadFuncional: "",
        piso: "",
        puerta: "",
        lote: "",
        manzana: "",
        unidadFuncionalM2: "",
        codigoUF: "",
        activo: true,
    };

    const [formData, setFormData] = useState(initialFormData);
    const [visible, setVisible] = useState(false);
    const [unidades, setUnidades] = useState([]);

    const handleChange = (campo, valor) => {
        setFormData((prev) => ({ ...prev, [campo]: valor }));
    };

    // â”€â”€â”€ Submit â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            ...formData,
            barrioId: barrio.id,
            administracionId,
        };
        try {
            await axios.post(`${HOST_API}api/unidadesFuncionales/saveUnidadFuncional`, payload);
            setVisible(false);
            fetchUnidades();
        } catch (err) {
            console.error(err);
        }
    };

    // â”€â”€â”€ Fetch â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const fetchUnidades = useCallback(async () => {
        if (!barrio?.id) return;
        setLoadingBackdrop(true);
        try {
            const response = await axios.get(
                `${HOST_API}api/unidadesFuncionales/getUnidadesFuncionales?unidadFuncionalId=0&administracionId=${administracionId}&barrioId=${barrio.id}`
            );
            console.log(response.data);
            setUnidades(response.data);
        } catch (err) {
            console.error(err.message || "Error al obtener unidades funcionales");
        } finally {
            setLoadingBackdrop(false);
        }
    }, [barrio?.id, administracionId]);

    useEffect(() => {
        fetchUnidades();
    }, [fetchUnidades]);

    const unidadesFlat = useMemo(() => unidades?.map(flattenRow) ?? [], [unidades]);

    const columns = useMemo(() => {
        if (!unidadesFlat?.length) return [];
        const firstRow = unidadesFlat[0];
        return Object.keys(firstRow)
            .filter((key) => !key.endsWith("_type") && key !== 'administracionId' && key !== 'barrioId' && key !== 'fechaAlta' && key !== 'activo')
            .map((field) => ({
                field,
                type: firstRow[`${field}_type`] ?? "text",
                header: field === 'unidadFuncional' ? t.UnidadFuncional : camelToHeader(field),
            }));
    }, [unidades, t.UnidadFuncional]);

    // â”€â”€â”€ Edit / Delete â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const handleEdit = (row) => {
        setFormData({ ...initialFormData, ...row });
        setVisible(true);
    };

    const handleDelete = (id) => {
        confirmDialog({
            message: `¿Estás seguro de eliminar este/a ${t.unidadFuncional}?`,
            header: 'Confirmar eliminación',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Eliminar',
            rejectLabel: 'Cancelar',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                try {
                    await axios.delete(`${HOST_API}api/unidadesFuncionales/deleteUnidadFuncional/${id}`);
                    fetchUnidades();
                } catch (err) {
                    console.error(err);
                }
            },
        });
    };

    // â”€â”€â”€ Render â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    return (
        <>
            <h4>{t.UnidadFuncional}</h4>
            <br />

            <ConfirmDialog />
            <Toast ref={toast} />
            <Dialog
                visible={loadingBackdrop}
                modal
                closable={false}
                showHeader={false}
                className="backdrop-dialog"
            >
                <ProgressSpinner style={{ width: '60px', height: '60px' }} />
            </Dialog>

            <div className="flex align-items-center gap-3 mb-3">
                <Button
                    label={`Nuevo/a ${t.unidadFuncional}`}
                    icon="pi pi-plus"
                    onClick={() => { setFormData(initialFormData); setVisible(true); }}
                />
            </div>

            <Dialog
                header={t.UnidadFuncional}
                visible={visible}
                style={{ width: "70vw" }}
                breakpoints={{ "960px": "100vw" }}
                modal
                onHide={() => setVisible(false)}
            >
                <form className="p-fluid grid" onSubmit={handleSubmit}>
                    <div className="col-12">
                        <div className="col-12 flex flex-wrap gap-3 mt-3">

                            <div className="w-full md:w-4">
                                <label>{t.UnidadFuncional}</label>
                                <InputText
                                    type="text"
                                    value={formData.unidadFuncional || ""}
                                    onChange={(e) => handleChange("unidadFuncional", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Código UF</label>
                                <InputText
                                    type="text"
                                    value={formData.codigoUF || ""}
                                    onChange={(e) => handleChange("codigoUF", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Dirección</label>
                                <InputText
                                    type="text"
                                    value={formData.direccion || ""}
                                    onChange={(e) => handleChange("direccion", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Bloque</label>
                                <InputText
                                    type="text"
                                    value={formData.bloque || ""}
                                    onChange={(e) => handleChange("bloque", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Piso</label>
                                <InputText
                                    type="text"
                                    value={formData.piso || ""}
                                    onChange={(e) => handleChange("piso", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Puerta</label>
                                <InputText
                                    type="text"
                                    value={formData.puerta || ""}
                                    onChange={(e) => handleChange("puerta", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Departamento</label>
                                <InputText
                                    type="text"
                                    value={formData.departamento || ""}
                                    onChange={(e) => handleChange("departamento", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>PH</label>
                                <InputText
                                    type="text"
                                    value={formData.ph || ""}
                                    onChange={(e) => handleChange("ph", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Lote</label>
                                <InputText
                                    type="text"
                                    value={formData.lote || ""}
                                    onChange={(e) => handleChange("lote", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Manzana</label>
                                <InputText
                                    type="text"
                                    value={formData.manzana || ""}
                                    onChange={(e) => handleChange("manzana", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>M²</label>
                                <InputText
                                    type="text"
                                    value={formData.unidadFuncionalM2 || ""}
                                    onChange={(e) => handleChange("unidadFuncionalM2", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Cochera</label>
                                <InputText
                                    type="text"
                                    value={formData.unidadComplementariaCochera || ""}
                                    onChange={(e) => handleChange("unidadComplementariaCochera", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Partida ARBA</label>
                                <InputText
                                    type="text"
                                    value={formData.partidaArba || ""}
                                    onChange={(e) => handleChange("partidaArba", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Plano UF</label>
                                <InputText
                                    type="text"
                                    value={formData.planoUnidadFuncional || ""}
                                    onChange={(e) => handleChange("planoUnidadFuncional", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4 flex align-items-center gap-2 mt-2">
                                <Checkbox
                                    inputId="activo"
                                    checked={formData.activo}
                                    onChange={(e) => handleChange("activo", e.checked)}
                                />
                                <label htmlFor="activo">Activo</label>
                            </div>

                            <div className="col-12 mt-3">
                                <Button label="Guardar" icon="pi pi-save" type="submit" />
                            </div>

                        </div>
                    </div>
                </form>
            </Dialog>

            <div className="grid">
                <div className="col-12">
                    <DataTable
                        value={unidadesFlat}
                        paginator
                        rows={10}
                        showGridlines
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        responsiveLayout="scroll"
                        emptyMessage="No hay unidades funcionales cargadas"
                        className="p-datatable-gridlines bg-white"
                    >
                        {columns.map(({ field, header, type }) => (
                            <Column
                                key={field}
                                field={field}
                                header={header}
                                sortable
                                body={(row) => formatValue(row[field], type)}
                            />
                        ))}
                        <Column
                            header="Estado"
                            style={{ width: '8rem' }}
                            body={(row) => row.activo
                                ? <span className="customer-badge status-ingreso">Activo</span>
                                : <span className="customer-badge status-renewal" style={{ background: '#fde8e8', color: '#c0392b' }}>No Activo</span>
                            }
                        />
                        <Column
                            header="Acciones"
                            style={{ width: '8rem' }}
                            body={(row) => (
                                <div className="flex gap-2 justify-content-center">
                                    <Button icon="pi pi-pencil" rounded text severity="warning" onClick={() => handleEdit(row)} tooltip="Editar" />
                                    <Button icon="pi pi-trash" rounded className="btn-delete" onClick={() => handleDelete(row.unidadFuncionalId)} tooltip="Eliminar" />
                                </div>
                            )}
                        />
                    </DataTable>
                </div>
            </div>
        </>
    );
};

export default UnidadFuncional;
